import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SupportModel } from '@models';

@Injectable({
  providedIn: 'root',
})
export class SupportApiService {
  getSupport(): Observable<SupportModel> {
    return http$.get<{ 'supportDTO': SupportModel }>('/AdminPanel/GetSupportForAdmin')
    .pipe(map(e => e.supportDTO));
  }

  updateSupport(dto: SupportModel): Observable<string> {
    return http$.put<string>('/AdminPanel/UpdateSupport', { supportInfo: dto });
  }
}